import { useTranslation } from '../../i18n/useTranslation';
import { Heading } from '../atoms/Typography/Heading';
import { Text } from '../atoms/Typography/Text';
import './TimelineEmptyState.css';

export function TimelineEmptyState() {
  const { t } = useTranslation();

  return (
    <div className="timeline-empty-state__container">
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        aria-hidden="true"
        className="timeline-empty-state__icon"
      >
        <circle cx="24" cy="24" r="20" stroke="currentColor" strokeWidth="2" />
        <path
          d="M24 14v10l6 6"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <Heading level={2} className="timeline-empty-state__heading">
        {t('timeline.empty.heading')}
      </Heading>
      <Text className="timeline-empty-state__description">
        {t('timeline.empty.description')}
      </Text>
    </div>
  );
}
